<script>
/**
 * NOTE1
 * 生成图片再添加到pdf中
 * 为了避免缩放，生成图片所用的dom 容器宽度是固定的810px
 * 但这个宽度在pc端上显得有点窄了，想个办法同步两个区域的内容
 * 每一个contenteditable 的class需要保持不同
 */

/**
 * NOTE2
 * 当页图片放不下就放下一页
 * 每一个风险可能都需要新开一页重新开始放
 * 可能需要预留图片位置
 */

/**
 * 样式调整
 * 所有所有 padding 为 0
 * margin 应该不会被包含在生成的图片里， 上下间距通过 padding 来设置
 * 分成多个区块，确保在同一层级，排除不需要打印的class
 */

import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

// 页面上下左右边距
const PAGE_MARGIN = 20;
// 页面尺寸差不多是这俩值，一边调一边试出来的
// 页面整体高度，包含上下边距
const PAGE_WIDTH = 810;
// 页面整体高度，包含上下边距
const PAGE_HEIGHT = 1240;
// 区块之间的距离
const BLOCK_MARGIN = 20;

export default {
  data() {
    return {
      renderList: [1, 2],
      list: [],
    };
  },
  mounted() {
    for (let i = 0; i < 4; i++) {
      this.list.push({
        id: Math.floor(Math.random() * 10000).toString(),
      });
    }
  },
  methods: {
    async fn() {
      try {
        console.log("开始导出");
        const ele = document.querySelector(".content-1 ul");
        // 判断缩放，Wind现在这样是可以的， MacOS 没机子测试
        const scale = window.devicePixelRatio;
        // 下载尺寸 a4 纸 比例
        let pdf = new jsPDF("p", "px", "a4");
        // 遍历出所有需要打印的节点
        const list = [...(ele.children || [])]
          ?.map((li) => {
            return [...(li.children || [])].filter(
              (el) => !el.className.includes("no-print")
            );
          })
          .flat(1);
        const urls = await Promise.all(
          list.map(async (el) => {
            const pdfCanvas = await html2canvas(el);
            return pdfCanvas.toDataURL();
          })
        );
        // y 是相对于页面顶部，所以需要累积已经放好的高度
        let currentHeightSum = 0;
        urls.forEach((url, idx) => {
          // 获取当前图片的信息，主要是高度
          const properties = pdf.getImageProperties(url);
          let width = properties.width / 2 / scale;
          let height = properties.height / 2 / scale;
          // 如果加上这张图，当页展示不全了，尝试新开一页，如果当前currentHeightSum 为0，尝试缩小图片
          if (
            currentHeightSum + properties.height + PAGE_MARGIN * 2 >
            PAGE_HEIGHT * scale
          ) {
            if (currentHeightSum === 0) {
              height = (PAGE_HEIGHT - PAGE_MARGIN * 2) / 2;
              width = (properties.width * height) / properties.height;
            } else {
              pdf.addPage();
              currentHeightSum = 0;
            }
          }
          pdf.addImage({
            imageData: url,
            compression: "FAST", // 压缩规则"NONE" | "FAST" | "MEDIUM" | "SLOW" 如果图片不清晰，尝试更换压缩规则
            x: PAGE_MARGIN, // 左边距
            // 我也不知道为什么要除以2 才行
            y: PAGE_MARGIN + currentHeightSum / 2 / scale, // 上边距
            width,
            height,
          });
          currentHeightSum += properties.height + BLOCK_MARGIN;
        });
        // 导出下载
        await pdf.save("report.pdf");
        console.log("导出完成");
      } catch (e) {
        console.log("导出出错", e);
      }
    },
    uploadImg(idx, e) {
      const files = e.target.files;
      if (!files.length) return;
      this.list = this.list.map((t, i) => {
        return {
          ...t,
          urls:
            idx === i
              ? [...files].map((file) => URL.createObjectURL(file))
              : t.urls,
        };
      });
    },
    liInput(idx, e) {
      const target = e.target;
      if (target.contentEditable === "true") {
        // 定位到触发input事件的div
        const className = target.className;
        // 找到另一个一模一样的dom，修改内容，生成图片
        const another = document.querySelector(
          `.content-1 li.list-${idx} .${className}`
        );
        another.innerHTML = target.innerHTML.replaceAll(
          /<img/g,
          "<img style='max-width: 100%' "
        );
      }
    },
  },
};
</script>

<template>
  <div style="z-index: 99; position: relative; background: white">
    <button @click="fn">export</button>
    <div
      v-for="renderIdx in renderList"
      :key="renderIdx"
      :class="`content-${renderIdx}`"
    >
      <ul>
        <li
          v-for="(item, idx) in list"
          :key="item.id"
          :class="`list-${idx}`"
          @input="(e) => liInput(idx, e)"
        >
          <div class="no-print">
            <span>上传一张图片，按钮不会被打印</span>
            <input
              type="file"
              multiple
              @change="(e) => uploadImg(idx, e)"
              accept="image/*"
            />
          </div>
          <div v-for="url in item.urls" :key="url">
            <img :src="url" alt="" />
          </div>
          <div class="no-print">这是一段描述性文字，他不会被打印</div>
          <!-- class需要保持不同 class1, class2 ...-->
          <div contenteditable class="class1">
            每个 <span style="color: red">Vue</span>
            在此过程中，它也会运行被称为生命周期钩子的函数，让开发者有机会在特定阶段运行自己的代码。它也会运行被称为生命周期钩子的函数，让开发者有机会在特定阶段运行自己的代码。组件实例在创建时都需要经历一系列的初始化步骤，比如设置好数据侦听，编译模板，挂载实例到
            DOM，以及在数据改变时更新
            DOM。在此过程中，它也会运行被称为生命周期钩子的函数，让开发者有机会在特定阶段运行自己的代码。
          </div>
          <div contenteditable class="class2">
            PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less" scoped>
.content-1 {
  max-width: 810px;
  height: 0;
  overflow-y: scroll;
}

ul {
  list-style: none;
  padding-left: 0;
}

img {
  //width: 100%;
  max-height: 400px;
  object-fit: contain;
  border: 1px solid #eee;
}
</style>
